import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlipCardComponent } from './flip-card.component';
import { ResizeObserverModule } from '../../directives';
import { FlipCardFrontDirective } from './flip-card-front.directive';
import { FlipCardBackDirective } from './flip-card-back.directive';

@NgModule({
  imports: [CommonModule, ResizeObserverModule],
  declarations: [
    FlipCardComponent,
    FlipCardFrontDirective,
    FlipCardBackDirective,
  ],
  exports: [FlipCardComponent, FlipCardFrontDirective, FlipCardBackDirective],
})
export class FlipCardModule {}
